import type { ComponentType, ReactNode } from "react";
import { MDXProvider } from "@mdx-js/react";
import { isExternal } from "@/lib/dates";

const components = {
  a: function MdxAnchor({
    href = "",
    children,
  }: {
    href?: string;
    children?: ReactNode;
  }) {
    if (isExternal(href)) {
      return (
        <a href={href} rel="noreferrer noopener">
          {children}
        </a>
      );
    }
    if (href.endsWith(".pdf")) {
      return (
        <a href={href} download>
          {children}
        </a>
      );
    }
    return <a href={href}>{children}</a>;
  },
};

export function MdxBody({ Component }: { Component: ComponentType }) {
  return (
    <div className="prose">
      <MDXProvider components={components}>
        <Component />
      </MDXProvider>
    </div>
  );
}
